import { createFileRoute } from "@tanstack/react-router";
import { useViewportSize } from "@/hooks/use-viewport-size";
import { WindowManager } from "@/components/desktop/window-manager";
import { desktopSearchSchema } from "@/lib/desktop-search";

/**
 * /dashboard — the main authenticated route.
 *
 * Renders the WindowManager into the DesktopShell's #stage (the shell is the
 * parent _authenticated layout). WindowManager auto-opens the dashboard window
 * on first visit; every other module window opens via desktop-icon clicks, the
 * dock, or the mobile drawer.
 *
 * Email-verification outcome is surfaced on /login (verify → sign in → welcome),
 * so this route no longer needs to handle a `?verified` param.
 */
function DashboardRoute() {
  const { isMobile } = useViewportSize();
  return <WindowManager isMobile={isMobile} />;
}

export const Route = createFileRoute("/_authenticated/dashboard")({
  /**
   * Makes the shell addressable: which window is focused and what it is
   * showing. Every param is optional, so a bare /dashboard behaves exactly
   * as before. See `@/lib/desktop-search` for why these are namespaced and
   * why window geometry deliberately stays out of the URL.
   */
  validateSearch: desktopSearchSchema,
  component: DashboardRoute,
});
